import React from "react";
import Breadcrumbs from "./Breadcrumbs";
import { ICONS, LOGOS } from "../utils/assets";
import Button from "./form/Button";
import { useGlobalStore } from "../stores/global-store";

const Header = ({ title, breadcrumbs }) => {
  const toggleSidebar = useGlobalStore((state) => state.toggleSidebar);

  return (
    <header className="header">
      <div className="header__info">
        <h1 className="text-sm text-neutral-950">{title || "Welcome back"}</h1>
        <Breadcrumbs items={breadcrumbs} />
      </div>
      <img
        src={LOGOS.QUICKMOVE_DASH}
        alt="Quickmove logo"
        className="header__logo"
      />

      <div className="header__actions">
        {/* <Button variant="icon-outlined" aria-label="Notifications">
          <img src={ICONS.BELL_ICON} alt="Notification icon" />
        </Button> */}
        <Button
          variant="icon-outlined"
          aria-label="Menu"
          customClass="menu"
          onClick={() => toggleSidebar()}
        >
          <img src={ICONS.MENU_ICON} alt="Menu icon" />
        </Button>
      </div>
    </header>
  );
};

export default Header;
